export default {"src":"/_next/static/media/smiling-dog-with-tongue.748ab55c.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};